import { render, staticRenderFns } from "./goods-select-modal.vue?vue&type=template&id=5ba7f118&scoped=true&"
import script from "./goods-select-modal.vue?vue&type=script&lang=js&"
export * from "./goods-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./goods-select-modal.vue?vue&type=style&index=0&id=5ba7f118&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7f118",
  null
  
)

export default component.exports